import React from 'react';
import { HubspotBanner } from './HubspotBanner';
import { authBannerLogin } from '../styles';

export const LoginBanner = (): JSX.Element => {
  const pageName = 'auth-login';

  return <HubspotBanner pageName={pageName} className={authBannerLogin} />;
};
